const ListForActionType = {
    SET_ITEM_LIST:'SET_ITEM_LIST',
    REMOVE_ITEM_FROM_LIST:'REMOVE_ITEM_FROM_LIST'
  }
  export default ListForActionType;